import { Badge as BasisBadge } from './basis/badge'

export const Badge = BasisBadge
